export const SELECT_REQUIREMENT_MODAL_ID = 'select-requirement-modal'
